<template>
	<div class="email-input">
		<div v-for="(email, index) in emailList" :key="index" class="email-item">
			<span>{{ email }}</span>
			<button type="button" @click="removeEmail(index)">X</button>
		</div>
			<input
				v-if="isInputVisible"
				type="text"
				class="form-control"
				name="emailSolicitante"
				id="emailSolicitante"
				v-model="newEmail"
				placeholder="Digite um novo e-mail"
				@keydown.space.prevent="addEmail"
			>
	</div>
</template>

<script>
export default {
	name: "MultiEmailInput",
	data() {
		return {
			emailList: [],
			newEmail: ''
		}
	},
	computed: {
		isInputVisible() {
			return this.emailList.length < 3;
		}
	},
	methods: {
		addEmail() {
			if (this.newEmail.trim() !== '' && this.emailList.length < 3) {
				this.emailList.push(this.newEmail.trim());
				this.newEmail = '';
				this.$emit('emails-updated', this.emailList);
			}
		},
		removeEmail(index) {
			this.emailList.splice(index, 1);
			this.$emit('emails-updated', this.emailList);
		}
	}
}
</script>

<style scoped>
.email-input {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	border: 1px solid #ccc;
	padding: 5px;
	width: 100%;
	border-radius: 4px;
}

.email-item {
	display: flex;
	align-items: center;
	margin-right: 5px;
	margin-bottom: 5px;
	border-radius: 3px;
	background-color: #eee;
	padding: 3px 6px;
}

.email-item span {
	margin-right: 5px;
}

.email-item button {
	border: none;
	background-color: transparent;
	color: #777;
	cursor: pointer;
	font-size: 14px;
	margin-left: 5px;
}
</style>
